import type { ServerResponseV1 } from "@/http"
import type { IReactionRequestV1 } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { v1 } from "@/axios"

interface AddReactionInput {
  reaction: IReactionRequestV1
  eventVaultId: number
}

export async function addReaction(
  reactionRequest: IReactionRequestV1,
  eventVaultId: number,
) {
  await v1.post<ServerResponseV1<void>>(
    `/guest/${eventVaultId}/react`,
    reactionRequest,
  )
}

export function useAddReaction() {
  return useMutation({
    mutationFn: ({ reaction, eventVaultId }: AddReactionInput) =>
      addReaction(reaction, eventVaultId),
  })
}
